module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAJBAMAAADN8WE8AAAAFVBMVEUAAACMp2SMp2SMp2SMp2SMp2SMp2RxrMl5AAAABnRSTlMAKu7q1yCCFSBZAAAAMUlEQVQI12MAAUEGKGA0FoCyhNMMoUJmackCUKE0oCBEKA0oCBECCUKEIIIhShDgCgBoNwvTsEI+bAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/about_turn_icon01.png
// module id = /8lp
// module chunks = 1